"use client";

import React from 'react';
import { useTranslations } from 'next-intl';
import StoryCard from './StoryCard';

const storyImages = [
    { imageUrl: "/images/about-us/icon1.png", alt: "Lamp", cardColor: "#F5F1E7" },
    { imageUrl: "/images/about-us/icon2.png", alt: "Team", cardColor: "#E0DCCF" },
    { imageUrl: "/images/about-us/icon3.png", alt: "Ai", cardColor: "#E4D8B7" },
];

function Story() {
    const t = useTranslations('aboutUs');
    const backgroundUrl = "/images/about-us/stepsBg.png";

    const cards = storyImages.map((img, index) => ({
        title: t(`storyCards.${index}.title`),
        description: t(`storyCards.${index}.text`),
        imageUrl: img.imageUrl,
        alt: img.alt,
        cardColor: img.cardColor,
    }));

    return (
        <section className="min-h-screen relative overflow-hidden">
            <div
                className="absolute inset-0 bg-gradient-to-b from-white to-[#F0ECE2]"
            ></div>

            <div
                style={{
                    backgroundImage: `url('${backgroundUrl}')`,
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                }}
                className="absolute inset-0 bg-contain bg-center bg-no-repeat bottom-[-90px] hidden md:block"
            ></div>

            <div className="relative z-10 w-full max-w-[950px] mx-auto px-4 md:px-5 py-[50px]">
                <h2 className="text-gray text-center text-[30px] md:text-[45px] leading-[55px] font-semibold mb-10">{t('storyTitle')}</h2>
                <div className="grid grid-cols-1 gap-x-[40px] gap-y-[50px] sm:gap-y-[40px] justify-items-center w-full mx-auto">
                    {cards.map((card, index) => (
                        <StoryCard
                            card={card}
                            key={index}
                            index={index}
                            isEven={index % 2 === 1}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Story;
